<template>
    <div>
        <div class="row">

            <h1 class="page-header">Validate Registered Members

                <span class="pull-right">
                    <file-uploader upload-url='/api/v1/members/validate_registered_members' v-on:file-uploaded="setCheckResult"></file-uploader>
                </span>
            </h1>
        </div>
        <div class="row">
            <h5>Using the Member Validation functionality in Swim Manager</h5>
            <p>This page allows you to upload an export from the Online Membership System (OMS) - it will then display differences between the registration information and the information in
                Swim Manager. It will also display a renewal action (Renew or Lapse) to help with annual renewals</p>
            <ul>
                <li>If a member is found in both Swim Manager and the OMS file, Swim Manager suggests that the membership should be renewed and highlights any differences between the information.</li>
                <li>If a member is in the OMS file, but not Swim Manager, Swim Manager suggests that the membership should be lapsed</li>
                <li>If a members is in Swim Manager and is a member of a Squad, but does not have a membership number, Swim Manager suggests that you should register this member.</li>
                <li>If there are members in Swim Manager with a membership number that is not in the OMS file, Swim Manager suggests that you should delete the member from Swim Manager.</li>
            </ul>
            <br />
        </div>

        <div class="row">
            <div class="table-responsive">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th class="text-center" colspan="2">First Name</th>
                    <th class="text-center" colspan="2">Last Name</th>
                    <th class="text-center" colspan="2">Middle Name</th>
                    <th class="text-center" colspan="2">Known As</th>
                    <th class="text-center" colspan="2">Membership No.</th>
                    <th class="text-center" colspan="2">Category</th>
                    <th class="text-center" colspan="2">Date Of Birth</th>
                    <th class="text-center" rowspan="2">Action</th>
                </tr>
                <tr>
                    <th class="text-center">SWM</th>
                    <th class="text-center">File</th>
                    <th class="text-center">SWM</th>
                    <th class="text-center">File</th>
                    <th class="text-center">SWM</th>
                    <th class="text-center">File</th>
                    <th class="text-center">SWM</th>
                    <th class="text-center">File</th>
                    <th class="text-center">SWM</th>
                    <th class="text-center">File</th>
                    <th class="text-center">SWM</th>
                    <th class="text-center">File</th>
                    <th class="text-center">SWM</th>
                    <th class="text-center">File</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(record,index) in checkResults" v-if="checkResults.length > 0">
                    <td :class="record.fields.first_name.field_class">{{ record.fields.first_name.swimmanager_value }}</td>
                    <td :class="record.fields.first_name.field_class" style="border-right: 1px solid;">{{ record.fields.first_name.csv_value }}</td>
                    <td :class="record.fields.last_name.field_class">{{ record.fields.last_name.swimmanager_value }}</td>
                    <td :class="record.fields.last_name.field_class" style="border-right: 1px solid;">{{ record.fields.last_name.csv_value }}</td>
                    <td :class="record.fields.middle_name.field_class">{{ record.fields.middle_name.swimmanager_value }}</td>
                    <td :class="record.fields.middle_name.field_class" style="border-right: 1px solid;">{{ record.fields.middle_name.csv_value }}</td>
                    <td :class="record.fields.known_as.field_class">{{ record.fields.known_as.swimmanager_value }}</td>
                    <td :class="record.fields.known_as.field_class" style="border-right: 1px solid;">{{ record.fields.known_as.csv_value }}</td>
                    <td :class="record.fields.asa_number.field_class">{{ record.fields.asa_number.swimmanager_value }}</td>
                    <td :class="record.fields.asa_number.field_class" style="border-right: 1px solid;">{{ record.fields.asa_number.csv_value }}</td>
                    <td :class="record.fields.membership_category_name.field_class">{{ record.fields.membership_category_name.swimmanager_value }}</td>
                    <td :class="record.fields.membership_category_name.field_class" style="border-right: 1px solid;">{{ record.fields.membership_category_name.csv_value }}</td>
                    <td :class="record.fields.date_of_birth.field_class">{{ record.fields.date_of_birth.swimmanager_value }}</td>
                    <td :class="record.fields.date_of_birth.field_class" style="border-right: 1px solid;">{{ record.fields.date_of_birth.csv_value }}</td>
                    <td :class="record.action_class">{{ record.action_label }}</td>
                </tr>
            </tbody>
        </table>
            </div>
        </div>
    </div>
</template>
<script>
    import { Loading } from 'element-ui';
    import lang from 'element-ui/lib/locale/lang/en';
    import locale from 'element-ui/lib/locale';
    locale.use(lang);

    export default {
        props: {
        },
        data: function () {
            return {
                text: '',
                checkResults: null
            }
        },
        computed: {
        },
        mounted() {
            this.debug('Registered Members Validate component mounted.');
        },
        methods: {
            checkData(text) {
                this.text = text;
            },
            setCheckResult(data) {
                this.checkResults = data;
            },
            debug(message) {
                console.log('TrainingSetList: ' + message);
            }
        }
    }
</script>